module.exports = __webpack_public_path__ + "open-sans-v17-latin-800.woff?05ebdbe10796850f045fcd484f35788d";